import styled from 'styled-components';

export const Container = styled.div`
    width: 150px;
    margin-top: 1rem;
    line-height: 30px;

    .icon-chat{
        cursor: pointer;
        float: right;
    }

    button{
        margin: 0;
    }

    .isMandatory {
        width: 12px;
        height: 12px;
        background-color: #cc0000;
        border-radius: 10px;
        position: absolute;
        top: -4px;
        right: -4px;
    }

    .icon-newdiscussion {
        height: 13px;
        width: 13px;
        max-width: 13px;
        min-height: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 1px;
        right: 8px;
        font-size: 10px;
        border-radius: 50%;
        background-color: red;
        font-weight: 400;
        color: white;
    }
`;